<template>
  <v-container id="product-list" fluid tag="section">
    <template v-if="errorMessage">
      <v-alert type="error">
        {{ errorMessage }}
      </v-alert>
    </template>
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>Tìm kiếm cuộc gọi</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card class="ma-0 overflow-visible" outlined>
            <v-list-item three-line class="overflow-visible pa-0">
              <v-list-item-content class="overflow-visible pa-0">

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="filterForm.keyword"
                      label="Tìm kiếm theo CHÍNH XÁC số điện thoại hoặc mã khách hàng"
                      placeholder="Nhập CHÍNH XÁC số điện thoại hoặc mã khách hàng" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete v-model="filterForm.status" :items="statusItems" item-text="name" item-value="id"
                      label="Tìm kiếm theo trạng thái" placeholder="Trạng thái" color="primary" multiple clearable
                      no-data-text="Không có dữ liệu" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <common-select-user class="btn-style-all" v-model="filterForm.userIds" :items="users"
                      item-text="fullName" item-value="id" placeholder="Tìm kiếm theo người phụ trách"
                      label="Người phụ trách" color="primary" multiple showInactive />
                  </v-col>
                  <v-col cols="12" md="6">
                    <common-range-picker :aLight="'left'" label="Tìm kiếm theo thời gian" v-model="selectRange"
                      :defaultRange="defaultRange" @change-date-range="changeDateRange" clearable />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete v-model="filterForm.callCenterId" :items="SWITCH_BOARD" item-text="name"
                      item-value="id" label="Tìm kiếm theo tổng đài" placeholder="Tổng đài" color="primary" clearable
                      no-data-text="Không có dữ liệu" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="filterForm.userExt" label="Tìm kiếm theo máy lẻ" placeholder="Máy lẻ" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete v-model="filterForm.audioFile" :items="audios" item-text="name" item-value="id"
                      label="Tìm kiếm theo file ghi âm" placeholder="Tìm kiếm theo file ghi âm" color="primary"
                      clearable no-data-text="Không có dữ liệu" />
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn class="primary mx-0" @click="searchData">
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-data-table :headers="headers" :items="tableData" item-key="id" class="table-layout pa-5" hide-default-footer>
      <template v-slot:top />

      <template v-slot:no-data>
        <common-no-result />
      </template>
      <template v-slot:item.customer.fullName="{ item }">
        {{ item.customer.fullName | hidePhone }}
      </template>
      <template v-slot:item.mobile="{ item }">
        {{ _.get(item, 'mobile', '') | hidePhone }}
        <v-btn size="small" rounder icon v-on="on" @click="copyMobile(item.mobile)">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-tooltip v-if="item.customer.contact && checkContactSources(item.customer.contact.contactSources)" bottom>
          <template v-slot:activator="{ on }">
            <v-btn size="16" width="20" height="20" class="mr-1" icon small color="info" v-on="on">
              <v-icon size="16">mdi-facebook-messenger</v-icon>
            </v-btn>
          </template>
          <span>Nhắn tin</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.customer.contact && item.customer.contact.contactType == 'main'">
          <template v-slot:activator="{ on }">
            <v-btn size="16" width="20" height="20" class="mr-1" icon small color="success" v-on="on">
              <v-icon size="16">mdi-account-multiple</v-icon>
            </v-btn>
          </template>
          <span>Contact chính</span>
        </v-tooltip>
        <v-tooltip bottom v-else-if="item.customer.contact && item.customer.contact.contactType == 'sub'">
          <template v-slot:activator="{ on }">
            <v-btn size="16" width="20" height="20" class="mr-1" icon small color="default" v-on="on">
              <v-icon size="16">mdi-account-multiple</v-icon>
            </v-btn>
          </template>
          <span>Contact phụ</span>
        </v-tooltip>
      </template>
      <template v-slot:item.contactCode="{ item }">
        {{ item.customer && item.customer.contactCode ? item.customer.contactCode : '--' }}
        <v-btn size="small" rounder icon v-on="on" @click="copyMobile(item.customer.contactCode, 'contactCode')">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.callAudioFile="{ item }">

        <div class="d-flex align-center justify-center" style="position: relative; max-width: 300px">
          <template v-if="item.audioFile && checkAuthorization('download-call-center-record_read')">
            <v-btn icon v-show="item.audioFile" dark small @click="playSound(item.id)" class="btn-override">
              <v-icon v-if="playing[item.id]" icon color="black">mdi-pause</v-icon>
              <v-icon v-else icon color="black">mdi-play</v-icon>
            </v-btn>
            <audio :id="`audio_${item.id}`" controls="false" class="audio-play mr-3" controlsList="nodownload">
              <source :src="item.audioFile">
            </audio>
          </template>
          <v-tooltip bottom v-if="item.audioFile">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="syncAudioFile(item)" class="mr-2">
                <v-icon color="primary" icon>mdi-sync</v-icon>
              </v-btn>
            </template>
            <span>Đồng bộ file ghi âm</span>
          </v-tooltip>
          <!--          <audio :id="`audio_${item.id}`" v-show="item.audioFile" class="audio-play mr-1" controls controlsList="nodownload">-->
          <!--            <source :src="item.audioFile">-->
          <!--          </audio>-->
          <v-tooltip bottom v-if="checkAuthorization('download-call-center-record_download')">
            <template v-slot:activator="{ on }" :id="`make-schedule-${item.id}`">
              <a :href="item.audioFile" v-show="item.audioFile" class="audio-file-link">
                <v-icon color="black" icon v-on="on">mdi-download</v-icon>
              </a>
            </template>
            <span>Tải file</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.callMakeSchedule="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }" :id="`make-schedule-${item.id}`">
            <v-btn @click="clickNewAppointment(item)" icon small color="primary" v-on="on">
              <v-icon>mdi-clock-outline</v-icon>
            </v-btn>
          </template>
          <span>Đặt lịch</span>
        </v-tooltip>
      </template>


    </v-data-table>
    <v-row>
      <v-col cols="12" sm="6" />
      <v-col cols="12" md="6" class="pb-0" style="display: flex; justify-content: flex-end; padding: 0 12px">
        <div class="text-right mb-1 mt-2">
          {{ showContactsIndex() }}
          <v-btn small class="pagination-btn-left" @click="function () { currentPage--; pendingPage-- }"
            :disabled="currentPage == 1">
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn small class="pagination-btn-right" @click="function () { currentPage++; pendingPage++ }">
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <div style="width: 35px">
          <v-text-field class="pt-0" v-model="pendingPage" min="1" step="1" type="number" @input="applyPendingPage()">
          </v-text-field>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'
const CallCenterRepository = RepositoryFactory.get('call_center');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
import * as moment from 'moment'
import { showFbMessengerIcon } from '@/helpers/utils'
import { SWITCH_BOARD } from '@/constants/common';
import TokenService from '@/helpers/token'

export default {
  components: {},
  data() {
    return {
      SWITCH_BOARD,
      isSearching: false,
      users: [],
      playing: {},
      tableData: [],
      headers: [
        {
          text: 'Khách hàng',
          align: 'center',
          sortable: false,
          value: 'customer.fullName',
        },
        { text: 'Số điện thoại', value: 'mobile', align: 'center', width: '165px' },
        { text: 'Mã khách hàng', value: 'contactCode', align: 'center', width: '165px' },
        /*{ text: 'Cuộc gọi', value: 'callDirection', align: 'center' },*/
        { text: 'Nhân viên chăm sóc', value: 'userFullName', align: 'center', width: '190px' },
        { text: 'Trạng thái', value: 'callStatus', align: 'center' },
        { text: 'Ngày', value: 'callDate', align: 'center' },
        { text: 'Thời gian', value: 'callTime', align: 'center' },
        { text: 'Thời lượng (giây)', value: 'duration', align: 'center', width: '165px' },
        { text: 'Ghi âm', value: 'callAudioFile', align: 'center' },
        { text: 'Đặt lịch', value: 'callMakeSchedule', sortable: false, align: 'center' },
      ],
      errorMessage: '',
      loading: false,
      filterForm: {
        keyword: '',
        status: [0],
        dateRange: {
          startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
          endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
        },
        userIds: [],
        audioFile: null,
      },
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      statusItems: [
        {
          id: 0,
          name: 'Tất cả'
        },
        {
          id: 1,
          name: 'Gọi đến lỡ'
        },
        {
          id: 2,
          name: 'Gọi đi lỡ'
        },
        {
          id: 4,
          name: 'Gọi đi thành công'
        },
        {
          id: 5,
          name: 'Gọi đến thành công'
        }
      ],
      defaultRange: {
        startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      },
      selectRange: [moment().startOf('isoWeek').format('YYYY-MM-DD'), moment().endOf('isoWeek').format('YYYY-MM-DD')],
      watchModule: '',
      audios: [
        { id: 1, name: "Chưa đồng bộ file ghi âm" },
        { id: 2, name: "Chưa có link file ghi âm" },
      ],
      pendingPage: 1,
    }
  },
  created() {
    const user = TokenService.getUser();
    if (user && user.position === 'staff') {
      this.headers = this.headers.filter(header => header.value !== 'mobile');
    }
    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          keyword: '',
          status: 0,
          dateRange: {
            startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
            endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
          },
          userIds: [],
        }
        this.selectRange = [moment().startOf('isoWeek').format('YYYY-MM-DD'), moment().endOf('isoWeek').format('YYYY-MM-DD')]

        if (this.currentPage === 1) {
          this.fetchTableData()
        } else {
          this.currentPage = 1
        }
        this.getUsers()
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    this.watchModule()
  },
  watch: {
    currentPage: {
      handler() {
        if (this.isSearching === false) {
          this.fetchTableData()
        }
      },
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.fetchTableData()
        } else {
          this.currentPage = 1
        }
      },
    },
  },
  async mounted() {

    if (!this.checkAuthorization('download-call-center-record_download') && !this.checkAuthorization('download-call-center-record_read')) {
      // if (!this.checkAuthorization('call_center_download')) {
      const indexHeaderDonwload = this.headers.findIndex(header => header.value === 'callAudioFile');
      this.headers.splice(indexHeaderDonwload, 1);
    }
    if (this.$route.query.keyword) {
      this.filterForm.keyword = this.$route.query.keyword;
    }

    this.getUsers();
    this.fetchTableData();
  },
  methods: {
    async syncAudioFile(item) {
      const payload = {
        id: item.id
      }
      const response = await CallCenterRepository.syncAudio(payload);
      if (response.success) {
        this.$swal({
          title: "Đã đồng bộ!",
          icon: "success",
          timer: 1500,
        });
        item.audioFile = response.data;
      } else {
        this.$swal({
          title: "Lỗi!",
          text: 'Đồng bộ file ghi âm không thành công',
          icon: "error",
        });
      }
    },
    copyMobile(mobile, type = "mobile") {
      navigator.clipboard.writeText(mobile);
      this.$swal({
        title: `Copy ${type === 'mobile' ? 'số điện thoại' : 'mã khách hàng'} thành công !`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    },
    playSound(id) {
      const a = document.getElementById(`audio_${id}`)
      this.$set(this.playing, id, !this.playing[id])
      if (a && this.playing[id]) {
        // find all audio
        Object.keys(this.playing).map(key => {
          if (+key !== id) {
            this.$set(this.playing, key, false)
          }
          const otherAudio = document.getElementById(`audio_${key}`)
          if (otherAudio) otherAudio.pause()
        });
        //play file
        a.play();
      } else if (a && !this.playing[id]) {
        // stop file
        a.pause();
      }
    },
    changeDateRange(dateRange) {
      this.filterForm.dateRange = dateRange
    },
    clickNewAppointment(appointment) {
      let sources = Array.from(appointment.customer.contact.contactSources, item => item.name)
      let contact = appointment.customer.contact
      const contactDetail = {
        contactId: _.get(appointment, 'customer.contactId', ''),
        fullName: _.get(appointment, 'customer.fullName', ''),
        mobile: _.get(appointment, 'mobile', ''),
        contactSources: sources.join(", "),
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0]
      }
      Bus.$emit('appointment-show-form-from-contact', contactDetail)
    },
    setAlertMessage(alert, type, text) {
      this.alert = alert
      this.alertMessageText = text
      this.alertMessageType = type
    },
    getColStatusText(status, duration, direction) {
      if (duration) {
        if (direction == 'outgoing') {
          return 'Gọi đi thành công'
        }
        return 'Gọi đến thành công'
      }
      if (direction == 'outgoing') {
        return 'Gọi đi lỡ'
      }
      else if (direction == 'incoming') {
        return 'Gọi đến lỡ'
      }
    },
    getColCallDate(callAt) {
      return moment(callAt).format('DD/MM/YYYY').toString()
    },
    getColCallTime(callAt) {
      return moment(callAt).format('HH:mm:ss').toString()
    },
    async searchData() {
      this.isSearching = true
      this.fetchTableData()
    },
    async fetchTableData() {
      this.errorMessage = '';
      this.loading = this.$loading.show();
      if (this.isSearching) {
        this.currentPage = 1
      }
      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: this.filterForm.keyword,
        status: this.filterForm.status,
        startDate: this.filterForm.dateRange.startDate ? moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD') : '',
        endDate: this.filterForm.dateRange.endDate ? moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD') : '',
        userIds: _.get(filterForm, 'userIds', []).filter(Boolean),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        callCenterId: this.filterForm.callCenterId,
        userExt: this.filterForm.userExt,
        audioFile: this.filterForm.audioFile,
      };

      const response = await CallCenterRepository.list(params)
      if (response.success) {
        this.tableData = _.get(response, 'data').map(data => {
          return {
            ...data,
            callDirection: data.type === 'outgoing' ? 'Gọi đi' : 'Gọi đến',
            callStatus: this.getColStatusText(data.status, data.duration, data.type),
            userFullName: _.get(data, 'user.fullName', ''),
            callDate: this.getColCallDate(data.callAt),
            callTime: this.getColCallTime(data.callAt),
          }
        })
        this.totalItem = parseInt(_.get(response, 'totalItem', 0), 10)
      } else {
        this.errorMessage = _.get(response, 'message', '')
      }
      this.loading.hide()
      this.isSearching = false
    },
    checkContactSources(contactSources) {
      return showFbMessengerIcon(contactSources)
    },
    async getUsers() {
      const res = await OrganizationMachineRepository.listUserContactAdvise({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    applyPendingPage: _.debounce(function () {
      this.currentPage = parseInt(this.pendingPage)
      return
    }, 500),
    showContactsIndex() {
      if (this.tableData.length > 0) {
        let maxIndex = parseInt(this.currentPage) * parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      } else {
        return ('0 - 0')
      }
    },
  },
  filters: {
    hidePhone(value) {
      if (!value) return '';
      return value.replace(/(\d{3})\d{3}(\d{4})/, '$1***$2');
    }
  }
}
</script>
<style scoped>
.audio-file-link {
  text-decoration: none;
}

.btn-override {
  position: absolute;
  z-index: 9;
  left: 13px;
}

.audio-play {
  max-width: 270px;
}
</style>
